import React from "react";
import { Link, useHistory, useParams } from "react-router-dom";

import Layout from "../../../../components/Layout";
import Container from "../../../../components/Container";
import Flex from "../../../../components/Flex";
import Content from "../../../../components/Content";
import Button from "../../../../components/Button";
import { useFetch } from "../../../../components/useFetch";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import Spinner from "../../../../components/Loader/Spinner";
import { useAuthState } from "../../../../components/AuthProvider";

import styles from "./ViewSystemNotification.module.scss";

const ViewSystemNotification = () => {
  const moment = require("moment-timezone");
  const clientConfigApiDomain = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
  const systemNotificationApiUrl = `${clientConfigApiDomain}/system_notifications`;

  const { id } = useParams();

  const history = useHistory();
  const { user } = useAuthState();

  const [{ data, isLoading, hasLoaded }, fetch] = useFetch();

  React.useEffect(() => {
    fetch({
      url: `${systemNotificationApiUrl}/${id}/`
    });
  }, [id, fetch, systemNotificationApiUrl]);

  let loadedBreadcrumbs = "";
  if (isLoading) {
    loadedBreadcrumbs = "Loading ...";
  } else if (hasLoaded) {
    loadedBreadcrumbs = (
      <Breadcrumbs>
        <Breadcrumbs.Item render={() => <Link to="/">Home</Link>} />
        <Breadcrumbs.Item
          render={() => <Link to="/admin">Administration</Link>}
        />
        <Breadcrumbs.Item
          render={() => (
            <Link to="/admin/systemnotifications">System Notifications</Link>
          )}
        />
        <Breadcrumbs.Item
          last
          render={() => `System Notification: ${data.id}`}
        />
      </Breadcrumbs>
    );
  }

  return (
    <Layout>
      <Container>
        <Flex gutter={3}>
          <Flex.Item span={12}>{loadedBreadcrumbs}</Flex.Item>
          {isLoading ? (
            <Spinner />
          ) : hasLoaded ? (
            <Flex.Item span={12}>
              <Content>
                <h1>System Notification: {data.id}</h1>
              </Content>
              <div className={styles.base}>
                <div className={styles.noticationSettings}>
                  <h3>System Notification Details</h3>
                  <div>
                    <Button
                      className={styles.margin}
                      primary
                      onClick={() => {
                        history.push(`/admin/systemnotifications/${id}/edit`);
                      }}
                    >
                      Edit
                    </Button>
                  </div>
                </div>
                <div className={styles.notificationDetails}>
                  <div>
                    <h4>System Notification ID</h4>
                    <span>{data.id}</span>
                  </div>
                  <div>
                    <h4>Message</h4>
                    <span>{data.message}</span>
                  </div>
                  <div>
                    <h4>Start Date</h4>
                    <span>{data.start_date}</span>
                  </div>
                  <div>
                    <h4>End Date</h4>
                    <span>{data.end_date}</span>
                  </div>
                  <div>
                    <h4>Created By</h4>
                    <span> {data.created_by} </span>
                  </div>
                  <div>
                    <h4>Date Created</h4>
                    <span>
                      {moment(data.created_at)
                        .tz(user.preferences.timeZone)
                        .format("L, LTS z")}
                    </span>
                  </div>
                  <div>
                    <h4>Updated By</h4>
                    <span>{data.updated_by}</span>
                  </div>
                  <div>
                    <h4>Date Updated</h4>
                    <span>
                      {moment(data.updated_at)
                        .tz(user.preferences.timeZone)
                        .format("L, LTS z")}
                    </span>
                  </div>
                </div>
              </div>
            </Flex.Item>
          ) : null}
        </Flex>
      </Container>
    </Layout>
  );
};

export default ViewSystemNotification;
